import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RequestStatus} from "../../utils/Enums";
import {apiClient} from "../../utils/ApiClient";
import Order from "../../models/Order";
import {extractExtractedOrderSearchParams} from "../../utils/SearchHelpers";

interface CheckerState {
    orders: Order[];
    currentPage: number;
    totalPages: number;
    getCheckerStatus: RequestStatus;
}

const initialState: CheckerState = {
    orders: [],
    currentPage: 1,
    totalPages: 1,
    getCheckerStatus: RequestStatus.Idle,
};

export const getChecker = createAsyncThunk(
    'orders/getChecker',
    async (type:string, {getState, rejectWithValue}) => {

        const state = getState() as { checker: CheckerState };
        const currentPage = state.checker.currentPage;

        const queryString = extractExtractedOrderSearchParams();

        const response = await apiClient.get(`checker/${type}?page=${currentPage}&${queryString}`);
        return response.data;

    }
);

const ordersSlice = createSlice({
    name: 'checker',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChecker.pending, (state, action) => {
                state.getCheckerStatus = RequestStatus.Loading;
            })
            .addCase(getChecker.fulfilled, (state, action) => {
                state.getCheckerStatus = RequestStatus.Success;
                state.orders = action.payload.data;
                state.currentPage = action.payload.current_page;
                state.totalPages = action.payload.last_page;
            })
            .addCase(getChecker.rejected, (state, action) => {
                state.getCheckerStatus = RequestStatus.Failed;
            })
    },
});

export default ordersSlice.reducer;